export default __webpack_public_path__ + "static/media/bboy.296a42f2.jpg";